export const initialValues = {
    advice: {
        adviceReceived: '',
    },
};

export const adviceOptions = [
    {
        label: 'Yes, from Pension Wise',
        value: `PensionWise`,
    },
    {
        label: 'Yes, from a financial adviser',
        value: `Adviser`,
    },
    {
        label: 'Yes, from Pension Wise and a financial adviser',
        value: 'PensionWiseAndAdviser',
    },
    {
        label: 'No, I chose not to contact Pension Wise or pay for financial advice',
        value: `None`,
    },
];

export const adviceValues = ['PensionWise', 'Adviser', 'PensionWiseAndAdviser'];
